import { DIETARY_ATTRIBUTES } from '../../../../views/phone-answering/constants';

export default {
  [DIETARY_ATTRIBUTES.DAIRY_FREE]: 'Milchfrei',
  [DIETARY_ATTRIBUTES.HALAL]: 'Halal',
  [DIETARY_ATTRIBUTES.SPICY]: 'Würzig',
  [DIETARY_ATTRIBUTES.VEGAN]: 'Vegan',
  [DIETARY_ATTRIBUTES.GLUTEN_FREE]: 'Glutenfrei',
  [DIETARY_ATTRIBUTES.VEGETARIAN]: 'Vegetarisch',
};
